(function () {
  'use strict';

  if (window.BCA_COLOMBIA_LOCATIONS_BRIDGE_V1) return;
  window.BCA_COLOMBIA_LOCATIONS_BRIDGE_V1 = true;

  var SHOPIFY_DATA_URL = String(window.BCA_COLOMBIA_LOCATIONS_ASSET_URL || '');
  var nativeFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
  var legacyPattern = /cdn\.jsdelivr\.net\/npm\/colombia-cities@1\.0\.0\/colombia_completa\.json(?:\?|$)/i;
  var cachedPayload = null;
  var inflight = null;

  if (!SHOPIFY_DATA_URL || !nativeFetch || typeof window.Response !== 'function') return;

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function cleanLocalName(value) {
    return String(value || '').trim();
  }

  function buildLegacyPayload(raw) {
    var departments = raw && Array.isArray(raw.data) ? raw.data : [];
    var seenDepartments = Object.create(null);
    var totalMunicipalities = 0;

    var converted = departments.map(function (department) {
      var depCode = cleanLocalName(
        department && department.code && department.code.id ||
        department && department.id ||
        ''
      );
      var depName = cleanLocalName(
        department && department.name && department.name.local ||
        department && department.name ||
        ''
      );
      var municipalities = department && Array.isArray(department.municipality)
        ? department.municipality
        : [];

      if (!depCode || !depName) {
        throw new Error('Bacanime locations: departamento inválido en la base local.');
      }

      if (seenDepartments[depCode]) {
        throw new Error('Bacanime locations: departamento duplicado ' + depCode + '.');
      }
      seenDepartments[depCode] = true;

      var seenCities = Object.create(null);
      var cities = municipalities.map(function (municipality) {
        var cityCode = cleanLocalName(
          municipality && municipality.code && municipality.code.id ||
          municipality && municipality.id ||
          ''
        );
        var cityName = cleanLocalName(
          municipality && municipality.name && municipality.name.local ||
          municipality && municipality.name ||
          ''
        );

        if (!cityCode || !cityName) {
          throw new Error('Bacanime locations: municipio inválido en ' + depName + '.');
        }
        if (seenCities[cityCode]) {
          throw new Error('Bacanime locations: municipio duplicado ' + cityCode + '.');
        }
        seenCities[cityCode] = true;
        totalMunicipalities += 1;

        return { codigo: cityCode, nombre: cityName };
      });

      return {
        codigo: depCode,
        nombre: depName,
        municipios: cities
      };
    });

    var expectedCounts = {
      CO91: 11, CO05: 125, CO81: 7, CO88: 2, CO08: 23, CO11: 1,
      CO13: 46, CO15: 123, CO17: 27, CO18: 16, CO85: 19, CO19: 42,
      CO20: 25, CO27: 30, CO23: 30, CO25: 116, CO94: 9, CO95: 4,
      CO41: 37, CO44: 15, CO47: 30, CO50: 29, CO52: 64, CO54: 40,
      CO86: 13, CO63: 12, CO66: 14, CO68: 87, CO70: 26, CO73: 47,
      CO76: 42, CO97: 6, CO99: 4
    };

    if (converted.length !== 33) {
      throw new Error('Bacanime locations: se esperaban 33 divisiones y llegaron ' + converted.length + '.');
    }
    if (totalMunicipalities !== 1122) {
      throw new Error('Bacanime locations: se esperaban 1122 municipios y llegaron ' + totalMunicipalities + '.');
    }

    converted.forEach(function (department) {
      var expected = expectedCounts[department.codigo];
      if (typeof expected !== 'number') {
        throw new Error('Bacanime locations: código de departamento no reconocido ' + department.codigo + '.');
      }
      if (department.municipios.length !== expected) {
        throw new Error('Bacanime locations: ' + department.nombre + ' debería tener ' + expected + ' municipios y llegaron ' + department.municipios.length + '.');
      }
    });

    if (!converted.some(function (d) { return d.codigo === 'CO25' && d.municipios.length === 116; })) {
      throw new Error('Bacanime locations: validación de Cundinamarca falló.');
    }
    if (!converted.some(function (d) { return d.codigo === 'CO11' && d.municipios.length === 1; })) {
      throw new Error('Bacanime locations: validación de Bogotá D.C. falló.');
    }

    return {
      departamentos: converted,
      _bca_source: 'shopify_theme_asset_open_admin_data',
      _bca_departments: converted.length,
      _bca_municipalities: totalMunicipalities
    };
  }

  function loadPayload(init) {
    if (cachedPayload) return Promise.resolve(cachedPayload);
    if (inflight) return inflight;

    inflight = nativeFetch(SHOPIFY_DATA_URL, {
      method: 'GET',
      credentials: 'omit',
      cache: 'force-cache',
      signal: init && init.signal ? init.signal : undefined
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Bacanime locations: Shopify no pudo servir la base local.');
      }
      return response.json();
    }).then(function (raw) {
      cachedPayload = buildLegacyPayload(raw);
      window.BCA_COLOMBIA_LOCATIONS_HEALTH = {
        ok: true,
        source: cachedPayload._bca_source,
        departments: cachedPayload._bca_departments,
        municipalities: cachedPayload._bca_municipalities,
        loadedAt: new Date().toISOString()
      };
      return cachedPayload;
    }).catch(function (error) {
      window.BCA_COLOMBIA_LOCATIONS_HEALTH = {
        ok: false,
        message: String(error && error.message || error),
        loadedAt: new Date().toISOString()
      };
      throw error;
    }).finally(function () {
      inflight = null;
    });

    return inflight;
  }

  window.fetch = function (input, init) {
    var url = getRequestUrl(input);

    if (!legacyPattern.test(url)) {
      return nativeFetch(input, init);
    }

    return loadPayload(init).then(function (payload) {
      return new Response(JSON.stringify(payload), {
        status: 200,
        statusText: 'OK',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Cache-Control': 'public, max-age=31536000, immutable',
          'X-Bacanime-Locations-Source': 'shopify-theme-local'
        }
      });
    }).catch(function () {
      return nativeFetch(input, init);
    });
  };
})();
